import { baseApi } from 'app/services/baseApi';

export interface CredentialInfo {
  docuSignUserId: string | null;
  docuSignAccessTokenExpirationDate: Date | null;
  docuSignRefreshTokenExpirationDate: Date | null;
  id: number;
  docuSignEmail: string;
  salesforceOrg: string;
}

export interface CredentialResponse {
  data: CredentialInfo;
  message: string;
}

export const docuSignApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getAllSharedCredentials: builder.query({
      query: () => ({
        url: 'docusignsharedcrendentials/',
        method: 'GET',
      }),
    }),

    getEnvelopeInfo: builder.query({
      query: (id: number) => ({
        url: `/docusignsigning/envelope/${id}`,
        method: 'GET',
      }),
    }),

    postCredential: builder.mutation({
      query: (email: string) => ({
        url: 'docusignsharedcrendentials/',
        method: 'POST',
        body: {
          docuSignEmail: email,
        },
      }),
      transformResponse(response: CredentialResponse, _meta, _arg) {
        const {
          data: { docuSignEmail },
        } = response;
        return docuSignEmail;
      },
    }),
  }),
});

export const { useGetAllSharedCredentialsQuery, usePostCredentialMutation, useGetEnvelopeInfoQuery } = docuSignApi;
